import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_URL = 'https://finline.sonbook.net';

interface PageMetaProps {
  title?: string;
  description?: string;
  canonical?: string;
}

export default function PageMeta({ title, description, canonical }: PageMetaProps) {
  const location = useLocation();

  useEffect(() => {
    const canonicalPath = canonical ?? location.pathname;

    if (title) {
      document.title = title;
    }

    let link: HTMLLinkElement | null = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'canonical';
      document.head.appendChild(link);
    }

    if (canonicalPath === '/' || canonicalPath === '/home') {
      link.setAttribute('href', `${BASE_URL}/`);
    } else {
      link.setAttribute('href', `${BASE_URL}${canonicalPath}`);
    }

    let metaDesc: HTMLMetaElement | null = document.querySelector('meta[name="description"]');
    if (description) {
      if (!metaDesc) {
        metaDesc = document.createElement('meta');
        metaDesc.name = 'description';
        document.head.appendChild(metaDesc);
      }
      metaDesc.setAttribute('content', description);
    }

    const ogTitle = document.querySelector('meta[property="og:title"]');
    const ogDesc = document.querySelector('meta[property="og:description"]');
    const ogUrl = document.querySelector('meta[property="og:url"]');
    const twitterTitle = document.querySelector('meta[name="twitter:title"]');
    const twitterDesc = document.querySelector('meta[name="twitter:description"]');

    if (title) {
      if (ogTitle) ogTitle.setAttribute('content', title);
      if (twitterTitle) twitterTitle.setAttribute('content', title);
    }
    if (description) {
      if (ogDesc) ogDesc.setAttribute('content', description);
      if (twitterDesc) twitterDesc.setAttribute('content', description);
    }
    if (ogUrl) {
      const ogUrlValue = canonicalPath === '/' ? BASE_URL + '/' : `${BASE_URL}${canonicalPath}`;
      ogUrl.setAttribute('content', ogUrlValue);
    }
  }, [title, description, canonical, location.pathname]);

  return null;
}